module.exports = __webpack_public_path__ + "static/media/blue-circle.d07798c9.png";